<template>
  <v-card title="考勤规则维护">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm title="确定删除吗?" @confirm="del(row)" @cancel="cancel" placement="bottom">
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red;">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: ""
};
export default {
  data() {
    return {
      options,
      checked: true,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center"
          },
          {
            field: "gzdm",
            title: "代码",
            align: "center"
          },
          {
            field: "gzmc",
            title: "名称",
            align: "center"
          },
          {
            field: "kssj",
            title: "当月考勤起始日",
            align: "center"
          },
          {
            field: "jssj",
            title: "次月考勤截止日",
            align: "center"
          },
          {
            field: "ycts",
            title: "考勤延迟天数",
            align: "center"
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios
        .get("api/system/kqgzwh/get-kqgz-list"
        )
        .then(res => {
          this.tableData = res.data;
        });
    },
    add: function (row) {
      let id = row == "" ? "" : row.id;
      let title = row == "" ? "添加考勤规则" : "修改考勤规则";
      xadmin.open(title, "/kqgzwhadd?id=" + id, "600", "500");
    },
    del: function (row) {
      this.$axios
        .get("api/system/kqgzwh/del-kqgz-list?id=" + row.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/kqgzwh.vue